module.exports = __webpack_public_path__ + "static/img/1.348025d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202107/1.png
// module id = o1XO
// module chunks = 0